import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import TaskComponent from "../../components/TaskComponent.jsx";
import ErrorBoundary from "../../components/ErrorBoundary";

/**
 * TaskFlyout — bottom-right popover for starting / switching the work task.
 *
 * Renders the existing self-contained <TaskComponent/> (Department + Task
 * dropdowns + Start). Picking and clicking Start runs the real start logic
 * (updateWorkHistoryThunk + addLatestReports + Starttask) — reused, not rebuilt.
 *
 * Unlike the old centered Modal, this lives inside the tray DOM so the tray's
 * click-outside handler (which also ignores antd dropdown portals) won't close
 * it while the user is choosing from a dropdown — fixing the "dropdown disables"
 * bug.
 *
 * Auto-closes once a task actually starts: Starttask stamps a fresh `time`
 * timestamp, so when state.timer.time changes from its value-at-open we close.
 */
const TaskFlyout = ({ onClose }) => {
  const time = useSelector((s) => s.timer?.time);
  const timeAtOpen = useRef(time);

  useEffect(() => {
    if (time !== timeAtOpen.current) onClose();
  }, [time, onClose]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="webtop-flyout webtop-task-flyout" role="dialog" aria-label="Start task">
      <div className="webtop-task-flyout__title">Start / switch task</div>
      <ErrorBoundary>
        <TaskComponent />
      </ErrorBoundary>
    </div>
  );
};

export default TaskFlyout;
